import { Check } from "lucide-react";
import { cn } from "@/lib/utils";
import { STEPS } from "../../lib/constants";

function done(n, insp, photos) {
  switch (n) {
    case 1: return !!insp.vehicle?.placa;
    case 2: return !!insp.reference?.referencia_zero;
    case 3: case 4: return (insp.points || []).length > 0;
    case 5: return (insp.anomalies || []).length > 0;
    case 6: return photos.length > 0;
    case 7: return !!insp.analysis;
    case 8: return !!insp.laudo;
    case 9: return !!insp.signature?.image;
    default: return false;
  }
}

export function StepNav({ step, onStep, insp, photos }) {
  return (
    <aside className="border-r border-[#1E2F45] bg-[#050B10] lg:sticky lg:top-[68px] lg:h-[calc(100vh-68px)] overflow-y-auto" data-testid="wizard-sidebar">
      <div className="p-4 hidden lg:block">
        <div className="caption-label">Etapas do relatório</div>
      </div>
      <nav className="flex lg:flex-col gap-1 px-2 pb-3 overflow-x-auto">
        {STEPS.map((s) => {
          const active = s.n === step;
          const ok = done(s.n, insp, photos);
          return (
            <button key={s.n} type="button" onClick={() => onStep(s.n)} data-testid={`wizard-step-${s.n}-button`}
              className={cn("group flex items-center gap-3 px-3 py-2.5 rounded-sm text-left border transition-colors shrink-0",
                active ? "bg-[#FFD500]/10 border-[#FFD500]/60" : "border-transparent hover:bg-[#0B1520] hover:border-[#1E2F45]")}>
              <span className={cn("h-7 w-7 shrink-0 flex items-center justify-center rounded-sm font-mono text-xs font-bold",
                active ? "bg-[#FFD500] text-[#050B10]" : ok ? "bg-[#10B981]/15 text-emerald-400 border border-emerald-500/40" : "bg-[#0B1520] text-slate-400 border border-[#1E2F45]")}>
                {ok && !active ? <Check size={14} strokeWidth={3} /> : s.n}
              </span>
              <span className={cn("text-sm leading-tight whitespace-nowrap lg:whitespace-normal", active ? "text-white font-semibold" : "text-slate-400 group-hover:text-slate-200")}>
                {s.title}
                {s.n === 4 && <span className="block font-mono text-[9px] tracking-widest text-[#FFD500]">RECURSO PRINCIPAL</span>}
              </span>
            </button>
          );
        })}
      </nav>
    </aside>
  );
}
